import { useEffect, useState } from "react";

import {
  addKeyboardListener,
  type KeyboardListenerHandle,
} from "../../../NativeAdapters/keyboard.adapter";

export interface UseIsKeyboardOpenProps {
  keyboardOpenEvent?: "keyboardDidShow" | "keyboardWillShow";
}

export function useIsKeyboardOpen(props: UseIsKeyboardOpenProps = {}) {
  const { keyboardOpenEvent = "keyboardDidShow" } = props;

  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  useEffect(() => {
    const keyboardOpenEventListener: Promise<KeyboardListenerHandle> = addKeyboardListener(
      keyboardOpenEvent,
      () => {
        setIsKeyboardOpen(true);
      }
    );

    const keyboardDidHideListener = addKeyboardListener("keyboardDidHide", () => {
      setIsKeyboardOpen(false);
    });

    return () => {
      keyboardOpenEventListener
        .then(async (listenerHandle) => {
          await listenerHandle.remove();
        })
        .catch(() => {
          // Ignore errors
        });
      keyboardDidHideListener
        .then(async (listenerHandle) => {
          await listenerHandle.remove();
        })
        .catch(() => {
          // Ignore errors
        });
    };
  }, [keyboardOpenEvent]);

  return isKeyboardOpen;
}
